import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { IonModal, IonIcon, IonText } from '@ionic/react';
import { close } from 'ionicons/icons';
import L from 'leaflet';
import moment from 'jalali-moment';
import 'leaflet.markercluster';
import 'leaflet/dist/leaflet.css';
import './HotelMap.css';
import mapMarkerImg from '../../../assets/images/map-marker.png';


interface Props {
    data: any,
    roomData?: any,
    item?: any,
    codeParentCallback: Function
}
const HotelMap = (props: Props) => {
    const location = useLocation();
    const currentPage = location.pathname;
    const [showHotelMapModal, setShowHotelMapModal] = useState(false);
    const hotelCode = useRef(0);
    useEffect(() => {
        if (showHotelMapModal) {
            if (props.data.length) {
                const mapOptions = {
                    center: [props.data[0].basicPropertyInfo.position.latitude, props.data[0].basicPropertyInfo.position.longitude],
                    zoom: 11,
                } as any;
                setTimeout(() => {
                    const myIcon = L.icon({
                        iconUrl: mapMarkerImg,
                        iconSize: [30, 43],
                        iconAnchor: [15, 43]
                    });
                    const mapEl = document.getElementById('hotelMapContainer');
                    if (mapEl) {
                        mapEl.innerHTML = "<div id='hotelMap' style='width: 100%; height: 100%;'></div>";
                        const map = L.map('hotelMap', mapOptions);
                        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                            maxZoom: 19,
                            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        }).addTo(map);
                        let markers = null as any;
                        markers = new L.MarkerClusterGroup();
                        props.data.forEach((item: any, index: number) => {
                            let mapHtml = '<article class="hotel-map-card" key={"index"' + index + '}>';
                            mapHtml += '<div class="d-flex">';
                            mapHtml += '<div class="image">';
                            mapHtml += '<img src="' + item.hotelImage + '">';
                            mapHtml += '</div>';
                            mapHtml += '<div>';
                            mapHtml += '<h6 class="title">' + item.hotelName + '</h6>';
                            mapHtml += '<span class="star d-flex">';
                            for (let x = 1; x <= 5; x++) {
                                if (x <= item.basicPropertyInfo.award[0].rating) {
                                    mapHtml += '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon s-ion-icon" viewBox="0 0 512 512"><title>Star</title><path d="M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z" stroke-linejoin="round" class="ionicon-stroke-width"></path></svg>';
                                } else {
                                    mapHtml += '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ionicon s-ion-icon" viewBox="0 0 512 512"><title>Star</title><path d="M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z" stroke-linejoin="round" class="ionicon-fill-none ionicon-stroke-width"></path></svg>';
                                }
                            }
                            mapHtml += '</span>';
                            mapHtml += '</div>';
                            mapHtml += '</div>';
                            mapHtml += '<div>';
                            mapHtml += '<div>';
                            if (props.item !== undefined) {
                                let passengersCount = 0;
                                props.item.hotelDefines.all[0].rooms.forEach((item: any) => {
                                    passengersCount = passengersCount + item.adults + item.childs
                                })
                                const reserveStartDate = moment(props.item.hotelDefines.all[0].dates.dates[0], 'YYYY-MM-DD');
                                const reserveEndDate = moment(props.item.hotelDefines.all[0].dates.dates[1], 'YYYY-MM-DD');
                                const reserveNightsCount = reserveEndDate.diff(reserveStartDate, 'days');
                                mapHtml += '<span class="price-info">هزینه ی ' + reserveNightsCount + ' شب برای ' + passengersCount + ' نفر</span>';
                            }
                            mapHtml += '<span class="price">';
                            mapHtml += item.price[0].amountAfterTax.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ریال';
                            mapHtml += '</span>';
                            mapHtml += '</div>';
                            mapHtml += '<div class="d-flex">';
                            if (currentPage !== '/hotel/reservation') {
                                mapHtml += '<button type="button" class="show-details" id="markerBtn' + index + '"> مشاهده جزئیات </button> ';
                            }
                            mapHtml += '</div>';
                            mapHtml += '</div>';
                            mapHtml += '</article>';
                            markers.addLayer(L.marker([item.basicPropertyInfo.position.latitude, item.basicPropertyInfo.position.longitude], { icon: myIcon }).bindPopup(mapHtml).on('popupopen', () => {
                                document.querySelector('#markerBtn' + index)?.addEventListener("click", () => {
                                    hotelCode.current = item.basicPropertyInfo.hotelCode;
                                    onCloseModal(hotelCode.current);
                                });
                            }));
                        });
                        map.removeLayer(markers);
                        map.addLayer(markers);
                    }
                }, 100);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data, showHotelMapModal]);
    const onCloseModal = (code = 0) => {
        if (code) {
            props.codeParentCallback(code);
        }
        setShowHotelMapModal(false);
        const mapEl = document.getElementById('hotelMapContainer');
        if (mapEl) {
            mapEl.innerHTML = "<div id='hotelMap' style='width: 100%; height: 100%;'></div>";
        }
    }
    return (
        <>
            <IonModal isOpen={showHotelMapModal} onDidDismiss={() => onCloseModal()} backdropDismiss mode="md" cssClass="hotel-map-modal">
                <div className="hotel-map-container">
                    <h3 className="hotel-map-modal-title">
                        مشاهده هتل روی نقشه
                        <IonIcon icon={close} onClick={() => onCloseModal()} />
                    </h3>
                    <div id="hotelMapContainer" className="hotel-map-container">
                        <div className="ring1">
                            <div className="ring2">
                                <div className="ring3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </IonModal>
            <IonText className="hotel-map-label" onClick={() => setShowHotelMapModal(true)}>مشاهده بر روی نقشه</IonText>
        </>
    );
};
export default HotelMap;